/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrialsControllerFindOneQueryResponse, TrialsControllerFindOnePathParams, TrialsControllerFindOneQueryParams, TrialsControllerFindOne400, TrialsControllerFindOne401, TrialsControllerFindOne403, TrialsControllerFindOne404 } from "../../models/trialsController/TrialsControllerFindOne";

function getTrialsControllerFindOneUrl(id: TrialsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/trials/${id}` as const }  
  return res
}

/**
 * @summary Get a trial by id
 * {@link /api/v1/trials/:id}
 */
export async function trialsControllerFindOne(id: TrialsControllerFindOnePathParams["id"], params?: TrialsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrialsControllerFindOneQueryResponse, ResponseErrorConfig<TrialsControllerFindOne400 | TrialsControllerFindOne401 | TrialsControllerFindOne403 | TrialsControllerFindOne404>, unknown>({ method : "GET", url : getTrialsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}